import React from "react";

import LexWorkplaceLogo from "../../svg/LexWorkplaceLogo";
import "./FullPageLoading.css";

const Loading = () => {
	return (
		<div className="full-page-loading">
			<div>
				<div className="animated-logo">
					<LexWorkplaceLogo />
				</div>
				<div className="loading-text">Loading...</div>
			</div>
		</div>
	);
};
export default Loading;
